import React from 'react';
import { Row, Col, Container } from '../../../../grid';
import { Table, Td } from '../../../../tables';
import { sanitizeMeasurement } from '../../../../../lib/helpers';
import {
  LiterFormat, MoneyFormat, PricePrLiterFormat, WeightFormat, LengthFormat,
} from '../../../../Format';
import { AlcoholPercentage } from '../../../parts';
import { sanitizePrice } from '../../../../../lib/price';

const Varedata = (props) => {
  const {
    liter,
    price,
    varenr,
    countPrColli,
    alcoholPercentage,
    weight,
    depth,
    height,
    totalCasePrice,
    contentCharge,
    ean,
    packageNoun,
    deposit,
    caseDeposit,
    containerCharge,
    width,
    energy,
    showOnlyPluralPrice,
    alcPctNum,
    showAlcPct,
    expiredMessage,
    productTypePack,
  } = props;

  if (expiredMessage || productTypePack) {
    return null;
  }

  return (
    <Container white>
      <Row paddingTop>
        <Col xs={12}>
          <Row>
            <Col xs={12} md={6} paddingTop="0px">
              <Table striped2 paddingTd="5px">
                <tr>
                  <Td width="70%">Varenr.:</Td>
                  <Td width="20%" textRight>{varenr}</Td>
                  <Td width="10%">&nbsp;</Td>
                </tr>
                {Boolean(ean) && ean !== '0' && (
                <tr>
                  <Td>EAN nr.:</Td>
                  <Td textRight>{ean}</Td>
                  <Td>&nbsp;</Td>
                </tr>
                )}
                {countPrColli > 1 && (
                <React.Fragment>
                  <tr>
                    <Td>Antal flasker:</Td>
                    <Td textRight>{countPrColli}</Td>
                    <Td>stk.</Td>
                  </tr>
                </React.Fragment>
                )}
                {Boolean(liter) && sanitizeMeasurement(liter) > 0 && (
                <tr>
                  <Td>Indhold liter i alt:</Td>
                  <Td textRight><LiterFormat liter={liter} noSuffix /></Td>
                  <Td>l</Td>
                </tr>
                )}
                {(alcPctNum > 0 || showAlcPct) && (
                <tr>
                  <Td>Alkohol %:</Td>
                  <Td textRight><AlcoholPercentage value={alcoholPercentage} noSuffix /></Td>
                  <Td>%</Td>
                </tr>
                )}
                {packageNoun !== 'Fustage' && !showOnlyPluralPrice && (
                <React.Fragment>
                  <tr>
                    <Td>Pris stk. uden moms:</Td>
                    <Td textRight><MoneyFormat money={price} multiplier={1 / countPrColli} moms={false} noSuffix /></Td>
                    <Td>kr.</Td>
                  </tr>
                  <tr>
                    <Td>Pris stk. med moms:</Td>
                    <Td textRight><MoneyFormat money={price} multiplier={1 / countPrColli} moms noSuffix /></Td>
                    <Td>kr.</Td>
                  </tr>
                </React.Fragment>
                )}
                <React.Fragment>
                  <tr>
                    <Td>Pris pr. {packageNoun.toLowerCase()} uden moms:</Td>
                    <Td textRight><MoneyFormat money={price} moms={false} noSuffix /></Td>
                    <Td>kr.</Td>
                  </tr>
                  <tr>
                    <Td>Pris pr. {packageNoun.toLowerCase()} med moms:</Td>
                    <Td textRight><MoneyFormat money={price} moms noSuffix /></Td>
                    <Td>kr.</Td>
                  </tr>
                </React.Fragment>
                {Boolean(liter) && sanitizeMeasurement(liter) > 0 && (
                <React.Fragment>
                  <tr>
                    <Td>Literpris uden moms:</Td>
                    <Td textRight><PricePrLiterFormat liter={liter} price={price} moms={false} noSuffix /></Td>
                    <Td>kr.</Td>
                  </tr>
                  <tr>
                    <Td>Literpris med moms:</Td>
                    <Td textRight><PricePrLiterFormat liter={liter} price={price} moms noSuffix /></Td>
                    <Td>kr.</Td>
                  </tr>
                </React.Fragment>
                )}
              </Table>
            </Col>
            <Col xs={12} md={6} paddingTop="0px">
              <Table striped2 paddingTd="5px">
                {Boolean(deposit) && sanitizePrice(deposit) > 0 && (
                <tr>
                  <Td>Pant pr flaske med moms:</Td>
                  <Td textRight><MoneyFormat money={deposit} multipler={1 / countPrColli} moms noSuffix /></Td>
                  <Td>kr.</Td>
                </tr>
                )}
                {Boolean(caseDeposit) && sanitizePrice(caseDeposit) > 0 && (
                <tr>
                  <Td>Pant kasse:</Td>
                  <Td textRight><MoneyFormat money={caseDeposit} moms noSuffix /></Td>
                  <Td>kr.</Td>
                </tr>
                )}
                {Boolean(totalCasePrice) && sanitizePrice(totalCasePrice) > 0 && (
                <tr>
                  <Td>Pant i alt med moms:</Td>
                  <Td textRight><MoneyFormat moms money={totalCasePrice} noSuffix /></Td>
                  <Td>kr.</Td>
                </tr>
                )}
                {Boolean(contentCharge) && sanitizePrice(contentCharge) > 0 && (
                <tr>
                  <Td>Indholdsafgift pr. {packageNoun.toLowerCase()} uden moms *:</Td>
                  <Td textRight><MoneyFormat moms={false} money={contentCharge} noSuffix /></Td>
                  <Td>kr.</Td>
                </tr>
                )}
                {Boolean(contentCharge) && sanitizePrice(contentCharge) > 0 && (
                <tr>
                  <Td>Indholdsafgift pr. {packageNoun.toLowerCase()} med moms *:</Td>
                  <Td textRight><MoneyFormat moms money={contentCharge} noSuffix /></Td>
                  <Td>kr.</Td>
                </tr>
                )}
                {Boolean(containerCharge) && sanitizePrice(containerCharge) > 0 && (
                <tr>
                  <Td>Emballageafgift pr. {packageNoun.toLowerCase()} *:</Td>
                  <Td textRight>
                    <MoneyFormat moms money={containerCharge} noSuffix />
                  </Td>
                  <Td>kr.</Td>
                </tr>
                )}
                {Boolean(weight) && sanitizeMeasurement(weight) > 0 && (
                <tr>
                  <Td>Vægt {packageNoun.toLowerCase()}:</Td>
                  <Td textRight><WeightFormat decimals weight={weight} /></Td>
                  <Td>kg.</Td>
                </tr>
                )}
                {Boolean(width) && sanitizeMeasurement(width) > 0 && (
                <tr>
                  <Td>Bredde {packageNoun.toLowerCase()}</Td>
                  <Td textRight><LengthFormat length={width} /></Td>
                  <Td>cm.</Td>
                </tr>
                )}
                {Boolean(depth) && sanitizeMeasurement(depth) > 0 && (
                <tr>
                  <Td>Længde {packageNoun.toLowerCase()}</Td>
                  <Td textRight><LengthFormat length={depth} /></Td>
                  <Td>cm.</Td>
                </tr>
                )}
                {Boolean(height) && sanitizeMeasurement(height) > 0 && (
                <tr>
                  <Td>Højde {packageNoun.toLowerCase()}</Td>
                  <Td textRight><LengthFormat length={height} /></Td>
                  <Td>cm.</Td>
                </tr>
                )}
                {Boolean(energy) && sanitizeMeasurement(energy) > 0 && (
                <tr>
                  <Td>Energi /100g:</Td>
                  <Td textRight>{energy}</Td>
                  <Td>kJ.</Td>
                </tr>
                )}
              </Table>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default Varedata;
